import React from 'react'

const PageLoader = () => {
  return (
    <>
      <div className='pageloader'>
        <div className="spinner-border z-1 text-light" role="status">
        </div>
      </div>
    </>
  )
}

export default PageLoader
